import { useQuery } from "@apollo/client/react";

import {
  AccountBlockedCountDocument,
  UserAssociationsDocument,
} from "@/graphql/codegen/graphql";
import { AssociationType } from "@/utils/constants";

type UserBlockDTO = {
  transactorPublicKey?: string;
  userPublicKey?: string;
};

export const useGetUserBlockedState = ({
  transactorPublicKey,
  userPublicKey,
}: UserBlockDTO) => {
  const { data, refetch, loading } = useQuery(UserAssociationsDocument, {
    variables: {
      filter: {
        transactor: {
          publicKey: {
            equalTo: transactorPublicKey,
          },
        },
        target: {
          publicKey: {
            equalTo: userPublicKey,
          },
        },
        associationType: {
          equalTo: AssociationType.block,
        },
      },
    },
    skip: !transactorPublicKey || !userPublicKey,
  });

  const count = data?.userAssociations?.totalCount ?? 0;
  const blockedUserPublicKey =
    data?.userAssociations?.nodes?.[0]?.target?.publicKey ?? null;
  return {
    loading,
    refetch,
    blocked: count > 0,
    blockedUserPublicKey,
    assosiationId: data?.userAssociations?.nodes?.[0]?.associationId ?? null,
  };
};

export const useGetViewerBlockedState = ({
  userPublicKey,
  viewerPublicKey,
}: {
  userPublicKey?: string;
  viewerPublicKey: string;
}) => {
  const { data, loading } = useQuery(AccountBlockedCountDocument, {
    variables: {
      publicKey: userPublicKey ?? "",
      filter: {
        target: {
          publicKey: {
            equalTo: viewerPublicKey,
          },
        },
        associationType: {
          equalTo: "BLOCK",
        },
      },
    },
    skip: !viewerPublicKey || !userPublicKey,
  });

  return {
    viewerIsBlocked:
      data?.accountByPublicKey?.viewerIsBlocked?.totalCount ?? 0 > 0,
    loading,
  };
};
